<section>

    <article class="card container-fluid">
        <h2 class="card-header text-center font-weight-bold text-uppercase py-4">Housing Provider Properties</h2>

        <!-- Header -->
        <article class="table-header">
          <!-- Toolbar -->
          <div class="toolbar">
            <!-- Copy GeoJSON Link -->
            <button type="button" class="dt-button" (click)="copyGeoJsonLink()">
              <span>Copy GeoJSON Link</span>
              <img class="arcgis-logo ml-2" src="/assets/arcgis-globe-icon.png" height="23">
            </button>

            <!-- Copy GeoRSS Link -->
            <button type="button" class="dt-button" (click)="copyGeoRssLink()">
              <span>Copy GeoRSS Link</span>
              <mdb-icon class="rss-icon ml-1 text-danger" fas icon="rss-square"></mdb-icon>
            </button>
          </div>
        </article>

        <!-- Table -->
        <div class="card-body" style="overflow-x:auto;">
            <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="stripe hover row-border order-column">
                <thead>
                    <tr>
                        <th>&nbsp;</th>
                        <th>&nbsp;</th>
                        <th>Entry Date</th>
                        <th>For Rent</th>
                        <th>Available Since</th>
                        <th>Address</th>
                        <th>City</th>
                        <th>ZipCode</th>
                        <th>Building #</th>
                        <th>Owner Name</th>
                        <th>Manager Name</th>
                        <th>Phone</th>
                        <th>Email</th>
                        <th>Building Units</th>
                        <th>Available Units</th>
                        <th>Property Note</th>
                        <th>Housing Vouchers Acceptance</th>
                        <th>Voucher Note</th>
                        <th>Certified Units?</th>
                        <th>Certified Unit Provider</th>
                        <th># Certified Units</th>
                        <th>Certified Unit Note</th>
                        <th>Lead Safe Units?</th>
                        <th>Lead Safe Provider</th>
                        <th># Lead Safe Units</th>
                        <th>Lead Safe Note</th>
                        <th>Latitude</th>
                        <th>Longitude</th>
                        <th>Building ADA Accessible</th>
                        <th>Unit ADA Accessible</th>
                        <th>Accessible Note</th>
                        <th>Incentive for Rentwise</th>
                        <th>Incentive Note</th>
                        <th>Edit/Delete</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let property of allProperties">
                        <td class="td-issues">
                          <div class="wrapper">
                            <mdb-icon *ngIf="duplicatesFoundBy(property) > 0" fas icon="exclamation-triangle" class="text-warning icon-duplicates"
                              [matTooltip]="duplicatesTooltip(property)" matTooltipPosition="above">
                            </mdb-icon>
                            <mdb-icon *ngIf="challengesFoundBy(property) > 0" fas icon="exclamation" class="text-danger icon-challenges"
                              [matTooltip]="challengesTooltip(property)" matTooltipPosition="above">
                            </mdb-icon>
                          </div>
                        </td>
                        <td>
                          <span *ngIf="duplicatesFoundBy(property) > 0">Duplicate</span>
                        </td>
                        <td class="text-nowrap" [attr.data-sort]="sortDate(property.entryDate)">{{ property.entryDate | date }}</td>
                        <td>{{ property.isAvailable ? 'Yes' : 'No' }}</td>
                        <td [attr.data-sort]="sortDate(property.availableSince)">{{ property.availableSince | date }}</td>
                        <td>{{ property.address }}</td>
                        <td>{{ property.city }}</td>
                        <td>{{ property.zipCode }}</td>
                        <td>{{ property.buildingNumber ? property.buildingNumber : 1 }}</td>
                        <td>{{ property.ownerName }}</td>
                        <td>{{ property.managerName }}</td>
                        <td>{{ property.contactPhone }}</td>
                        <td>{{ property.email }}</td>
                        <td>{{ property.buildingUnits ? property.buildingUnits : 1 }}</td>
                        <td>{{ property.availableUnits ? property.availableUnits : 0 }}</td>
                        <td>{{ property.propertyNote }}</td>
                        <td>{{ property.hcvCheck ? 'Yes' : 'No' }}</td>
                        <td>{{ property.hcvNote }}</td>
                        <td>{{ property.cuCheck ? 'Yes' : 'Info Unavailable' }}</td>
                        <td>{{ property.cuProvider }}</td>
                        <td>{{ property.cuUnits }}</td>
                        <td>{{ property.cuNote }}</td>
                        <td>{{ property.lsCheck ? 'Yes' : 'Info Unavailable' }}</td>
                        <td>{{ property.lsProvider }}</td>
                        <td>{{ property.lsUnits }}</td>
                        <td>{{ property.lsNote }}</td>
                        <td>{{ property.latitude }}</td>
                        <td>{{ property.longitude }}</td>
                        <td>{{ property.buildingAdaAccessible | boolean:'Yes':'No' }}</td>
                        <td>{{ property.unitAdaAccessible | boolean:'Yes':'No' }}</td>
                        <td>{{ property.accessibleNote }}</td>
                        <td>{{ property.incentiveForRentwise | boolean:'Yes':'No' }}</td>
                        <td>{{ property.incentiveNote }}</td>
                        <td>
                            <button type="button" (click)="editProperty(property)"><mdb-icon fas icon="pen"></mdb-icon></button>
                            <button type="button" (click)="deleteProperty(property)" class="ml-2 btn-danger"><mdb-icon fas icon="trash"></mdb-icon></button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </article>
</section>
